import $ from "jquery";

! function () {
  "use strict"; // jshint;

  /**
   * Form slider is a simple element that designed to slide content like horizontal gallery.
   * Slider can be moved by navigation menu or buttons inside each slide (if they exist)
   *
   * The markup for slider looks like:
   *
   * <div class="fslider">
   *   <div class="fslider-navigation"></div>
   *   <div class="fslider-wrapper">
   *      <div class="fslider-element">
   *        <div class="fslider-step fslider-step-1"></div>
   *        <div class="fslider-step fslider-step-2"></div>
   *      </div>
   *   </div>
   * </div>
   *
   * @param container Element which wraps navigation menu and slider
   * @param element Slider element wrapper
   * @param navigation Slider navigation menu
   * @param settings Custom options, such as selectors to get slider items and "continue" buttons
   * @constructor
   */
  var FormSlider = function (container, element, navigation, settings) {
    var self = this;

    this.options = $.extend(this.defaults, settings); // merge options
    this.$container = $(container).addClass("fslider");
    this.$navigation = $(navigation).addClass("fslider-navigation");
    this.$element = $($(element).addClass("fslider-element-wrapper").children().eq(0)).addClass("fslider-element");
    this.currentStep = -1; // null current step

    // hide all steps except first one
    var $slides = this.$element.find(this.options.slideSelector).slice(2).hide().end();

    /**
     * Calculate width for each slide
     */
    var updateWidth = function () {
      var slideWidth = parseInt($(element).css("width"));
      $slides.css("width", slideWidth);

      // apply proper width to parent wrapper
      self.$element
        .css("width", slideWidth * $slides.length);
    };
    updateWidth();

    // listen window resize event
    $(window).resize(updateWidth);

    // go through all slides and make them as wide as parent element
    $slides
      .hide()
      .each(function (i) {
        var $slide = $(this),
          index = i;

        $slide
          .addClass("fslider-step fslider-step-" + index)
          .css({
            float: "left",
            display: "block"
          })
          .find(self.options.slideContinueButtonSelector)
          .click(function () {
            self.slideTo(index + 1);
            return false; // just to be sure we prevented native behaviour
          });
      });

    // open first step by default
    this.jumpTo(settings.current || this.$container.attr("data-active-step") || 0);

    // bind navigation selection
    this.$navigation
      .find("li a:not([disabled='disabled'])")
      .click(function () {
        self.slideTo($(this).parent().index());
      });

    this.count = function () {
      return $slides.length;
    };

  };

  /**
   * Form slider is a simple element that designed to slide content like horizontal gallery
   *
   * @type {{defaults: {slideSelector: string, slideContinueButtonSelector: string}, constructor: Function, slideTo: Function}}
   */
  FormSlider.prototype = {
    defaults: {
      "slideSelector": ".fslider-step",
      "slideContinueButtonSelector": ".fslider-continue-btn"
    },
    constructor: FormSlider,

    /**
     * Slide to specified step
     * @param index
     */
    slideTo: function (index) {
      if (this.currentStep === index) return;

      this.$container.attr("data-active-step", index).addClass("is-active-step-" + index).removeClass("is-active-step-" + this.currentStep);
      this.currentStep = index;
      var isLast = index + 1 === this.count();

      this.$container.trigger("onSelect", [index, isLast]);
    },

    /**
     * Jump without transitions to specified step
     * @param index
     */
    jumpTo: function (index) {
      if (this.currentStep === index) return;

      var self = this,
        duration = this.$element.css("webkitTransitionDuration") || this.$element.css("mozTransitionDuration") || this.$element.css("transitionDuration");

      // keep transition time
      this.$element.css({
        "webkitTransitionDuration": "0s",
        "mozTransitionDuration": "0s",
        "transitionDuration": "0s"
      });

      this.$container.attr("data-active-step", index).addClass("is-active-step-" + index).removeClass("is-active-step-" + this.currentStep);
      this.currentStep = index;

      // small timeout to prevent transition
      setTimeout(function () {
        self.$element.css({
          "webkitTransitionDuration": duration,
          "mozTransitionDuration": duration,
          "transitionDuration": duration,
          "transform": "translate3d(0px, 0px, 0px)",
        });
      }, 100)

    }
  };



  /* JQuery plugin wrapper
   * ======================= */
  $.fn.fslider = function (element, navigation, options) {
    return this.each(function () {
      var $this = $(this),
        data = $this.data('slider');

      if (!data) $this.data('slider', new FormSlider(this, element, navigation, options));
    })
  };

  $.fn.fslider.Constructor = FormSlider;
}();
